import React, {useMemo, useReducer, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useEngagementId} from '../../../../../../../util/customHooks';
import {sampleItemFilterKeys} from '../../../../../../../util/uiconstants';
import SampleItemFilter from './SampleItemFilter';
import SampleItemFilterControls from './SampleItemFilterControls';
import getFilterConfig from './Config';
import StyledSampleItemToolbar from './StyledSampleItemToolbar';

export function SampleItemToolbar(props) {
	const {actions, location, searchString, setSearchString} = props;
	const dispatchAction = useDispatch();
	const customFilter = useSelector((state) => state.filter);
	const engagementId = useEngagementId();
	const {sampleItemFilterConfig} = getFilterConfig(
		sampleItemFilterKeys.sampleItemFilter,
		engagementId,
		dispatchAction
	);
	useEffect(() => {
		if (
			customFilter?.sampleItemFilter?.sampleItemListKey?.value !== undefined 
		) {
			dispatch({
				type: 'state/set',
				value: {
					filters: {...customFilter.sampleItemFilter}
				}
			});
		} else if (
			customFilter?.sampleItemFilter?.sampleItemListKey?.value === undefined 
		) {
			dispatch({
				type: 'state/set',
				value: {
					filters: {
						...customFilter,
						sampleItemFilter: {}
					}
				}
			});
		}
	}, [customFilter]);

	const renderFilters = {};

	const Toolbar = {
		filters: {
			renderItem: (props) => (
				<SampleItemFilter
					engagement={engagementId}
					filterConfiguration={props.filterConfiguration}
					state={props.state}
					setState={props.setState}
					history={props.history}
					dispatch={props.dispatch}
					searchString={searchString}
					setSearchString={setSearchString}
				/>
			),
			onRender: (args, renderProps) => {
				var filterConfiguration = sampleItemFilterConfig;
				renderProps.filterConfiguration = filterConfiguration;
				renderProps.filterConfiguration.state = !customFilter.isLoaded
					? undefined
					: renderProps.filterConfiguration.state;
			}
		},
		controls: {
			renderItem: (props) => (
				<SampleItemFilterControls
					engagement={engagementId}
					filterConfiguration={props.filterConfiguration}
					state={props.state}
					setState={props.setState}
					history={props.history}
					dispatch={props.dispatch}
				/>
			)
		}
	};

	const toolbar = [
		{
			className: 'FirstRow',
			components: [Toolbar.filters, Toolbar.controls]
		}
	];

	const [renderProps] = useMemo(() => {
		let renderProps, filterKey;

		if (toolbar?.length > 0) {
			renderProps = {
				engagementId
			};

			for (let i = 0; i < toolbar.length; i++) {
				const row = toolbar[i];

				for (let k = 0; k < row.components.length; k++) {
					const component = row.components[k];

					if (component.onRender) {
						component.onRender(
							{
								actions,
								location,
								engagementId,
								renderFilters,
								filterKey: component.filterKey,
								history: props.history
							},
							renderProps
						);
					}
				}
			}

			filterKey = renderProps.filterConfiguration?.key;
		}

		return [renderProps, filterKey];
	}, [engagementId]);

	const reducer = (state, action) => {
		switch (action.type) {
			case 'state/set':
				return {
					...state,
					...action.value
				};

			default:
				return state;
		}
	};

	let initialState = {};
	if (renderProps.filterConfiguration) {
		initialState.filters = renderProps.filterConfiguration.state;
	}

	const [state, dispatch] = useReducer(reducer, initialState);
	return (
		<StyledSampleItemToolbar className="StyledSampleItemToolbar">
			{toolbar.map((row, index) => (
				<section key={`auditPlan-list-toolbar-${index}`} className={row.className} style={row.style}>
					{row.components &&
						row.components.map((component) =>
							component.renderItem({
								...renderProps,
								history: props.history,
								state,
								dispatch
							})
						)}
				</section>
			))}
		</StyledSampleItemToolbar>
	);
}
export default SampleItemToolbar;